<template>
  <v-btn
    icon
    elevation="0"
    @click="toggleSidebar"
    color="primary"
  >
    <v-icon>{{ isMobile ? (Sidebar_drawer ? 'mdi-menu-open' : 'mdi-menu') : (mini_sidebar ? 'mdi-menu' : 'mdi-menu-open') }}</v-icon>
  </v-btn>
</template>

<script>

import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState(["mini_sidebar", "Sidebar_drawer", "isMobile"]),
   
  },
  methods: {
    ...mapMutations(["SET_MINI_SIDEBAR", "SET_SIDEBAR_DRAWER"]),
    toggleSidebar() {
      if (this.isMobile) {
        this.SET_SIDEBAR_DRAWER(!this.Sidebar_drawer);
        const sidebar = document.querySelector(".leftSidebar");
      if (sidebar) {
        sidebar.style.display = this.Sidebar_drawer ? "flex" : "none";
      }
      } else {
        this.SET_MINI_SIDEBAR(!this.mini_sidebar); // Toggle mini mode on desktop
      }
    },
  },
};
</script>

<style scoped>
/* Add any necessary styles */
</style>
